export default __webpack_public_path__ + "static/media/logo.0251ccc1.svg";